import React, { memo } from 'react';
import ContentLoader from 'react-content-loader';
import { Main } from '../../components/layouts/common/containers';

/**
 * @description Render memoized loader component
 * @param {Object} location
 * @returns {JSX.Element} Memoized loader component
 */
export const Loader = memo(function MemoizedLoader() {
  return (
    <Main className="flex items-center justify-center">
      <ContentLoader viewBox="0 0 400 160" height={160} width={400} backgroundColor="transparent">
        <circle cx="150" cy="86" r="8" />
        <circle cx="194" cy="86" r="8" />
        <circle cx="238" cy="86" r="8" />
      </ContentLoader>
    </Main>
  );
});
